angular.module('filters').filter('mediumDate', function() {
  return function(input) {
    if (input) {
      return moment(input).format('MMM D, YYYY h:mma');
    }
  };
});
